
/**
 * 
 * @param {File} file 
 */
export function validateFile(file) {
    if(file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        return error("Please select an excel file.");
        
    return { ok: true };
}

function error(error) {
    return { ok: false, error };
}